import { type IntlShape } from 'react-intl';
import {
  PROVIDER_TITLES,
  type ProviderTitleKey,
} from '../constants/providerTitles';

export type GetProviderNameArgs = {
  title?: string | null;
  firstName: string;
  lastName: string;
  displayName?: string | null;
  /**
   * Will be null when called outside the React context
   */
  formatMessage?: IntlShape['formatMessage'];
};

const isNotEmpty = (value?: string | null): value is string =>
  typeof value === 'string' && value.trim().length > 0;

const concatenate = (array: (string | null | undefined)[]): string =>
  array
    .map((s) => s?.trim())
    .filter((s) => s !== undefined)
    .join(' ')
    .trim();

/**
 * @returns The correct provider name:
 * - displayName if set, e.g. "Dr. John Doe"
 * - title & last name if title is set, e.g. "Dr. Doe"
 * - first name & last name, e.g. "John Doe"
 */
export const getProviderName = ({
  title,
  firstName,
  lastName,
  displayName,
  formatMessage,
}: GetProviderNameArgs): string => {
  if (isNotEmpty(displayName)) {
    return displayName.trim();
  }

  if (isNotEmpty(title) && title !== 'Other') {
    return concatenate([
      formatMessage
        ? formatMessage({ id: PROVIDER_TITLES[title as ProviderTitleKey] })
        : title,
      lastName,
    ]);
  }

  return concatenate([firstName, lastName]);
};
